import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-bank-accounts',
	templateUrl: './bank-accounts.component.html',
	styleUrls: ['./bank-accounts.component.css'],
})
export class BankAccountsComponent extends ListComponent {
	protected apiUrl = 'bankAccounts';
	tableRows = [
		{ id: 'number', name: 'Numer' },
		{ id: 'saldo', name: 'Saldo' },
		{ id: 'currentOwnerName', name: 'Obecny właściciel' },
	];
	addNumber = '';
	filters = {
		status: 1,
		withSaldo: 1,
	};

	dialogOpen() {
		this.addNumber = '';
		new Modal(document.getElementById('addModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	submit() {
		this.api.post('/bankAccounts/', { number: this.addNumber }, (result, error) => {
			let router: Router;
			router.navigate(['bankAccounts', result.data]);
		});
		this.dialogClose();
	}
}
